<ng-template #modalLG let-modal style="border-radius: 8px">
    <div class="modal-header detail-inventaire-popup__header">
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Fermer">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body detail-inventaire-modal detail-inventaire-popup" tabindex="0" ngbAutofocus>
            <p class="detail-inventaire-popup__doc-title size18">
                <strong>{{ documentType }}</strong>
                <span class="detail-inventaire-popup__doc-sep">/</span>
                <span class="detail-inventaire-popup__doc-ref">{{ refExterne }}</span>
            </p>

            <div *ngIf="isLoading" class="text-center p-4">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Chargement...</span>
                </div>
            </div>

            <div *ngIf="!isLoading">
                <div class="d-flex justify-content-between">
                    <div class="mt-3 d-flex">
                        <div class="calendar">
                            <i data-feather="calendar" [size]="18"></i>
                        </div>
                        <div class="mx-2">
                            <span class="text-muted">{{ documentDate }}</span> <br>
                            <span class="text-black">Date</span>
                        </div>
                    </div>

                    <div class="mt-3 d-flex">
                        <div class="check">
                            <i data-feather="check" [size]="18"></i>
                        </div>
                        <div class="mx-2">
                            <span class="text-vert">{{ documentStatut }}</span> <br>
                            <span class="text-black">Statut</span>
                        </div>
                    </div>

                    <div style="margin-left: 16px;">
                        <div class="border-dashed rounded text-center total-box">
                            <div class="mt-2 mb-1 text-primary fw-bold">
                                <strong class="size20"> {{ netPayer }} TND </strong>
                            </div>
                            <p class="size15 text-black">Montant total</p>
                        </div>
                    </div>
                </div>

                <div class="d-flex align-items-center gap-2 detail-inventaire-tabs">
                    <button type="button"
                            class="tab-button"
                            [class.tab-active]="activeTab === 'article'"
                            [class.tab-inactive]="activeTab !== 'article'"
                            (click)="setActiveTab('article')">
                        <i data-feather="user" [size]="16"></i>
                        <span>Articles</span>
                    </button>
                    <button type="button"
                            class="tab-button"
                            [class.tab-active]="activeTab === 'paiement'"
                            [class.tab-inactive]="activeTab !== 'paiement'"
                            (click)="setActiveTab('paiement')">
                        <i data-feather="dollar-sign" [size]="16"></i>
                        <span>Paiement</span>
                    </button>
                    <button type="button"
                            class="tab-button"
                            [class.tab-active]="activeTab === 'document-lies'"
                            [class.tab-inactive]="activeTab !== 'document-lies'"
                            (click)="setActiveTab('document-lies')">
                        <i data-feather="lock" [size]="16"></i>
                        <span>Documents Liés</span>
                    </button>
                </div>

                <div *ngIf="activeTab === 'article'" class="detail-inventaire-tab-panel">
                <div class="detail-inventaire-table-scroll">
                    <table class="styled-table w-full detail-inventaire-lines products-table detail-articles-table">
                        <colgroup>
                            <col class="detail-col-code-barre" />
                            <col class="detail-col-designation" />
                            <col class="detail-col-qty" />
                            <col class="detail-col-remise" />
                            <col class="detail-col-price" />
                            <col class="detail-col-price" />
                        </colgroup>
                        <thead>
                        <tr class="detail-inventaire-articles-thead-row">
                            <th class="detail-th-code-barre">CODE À BARRE</th>
                            <th class="detail-th-produit">PRODUIT</th>
                            <th class="detail-th-num detail-th-qty">QUANTITÉ</th>
                            <th class="detail-th-num detail-th-remise">REMISE</th>
                            <th class="detail-th-num detail-th-price">{{ getDetailFirstPriceLabel() }}</th>
                            <th class="detail-th-num detail-th-price">{{ getDetailSecondPriceLabel() }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngIf="lignesDocument.length === 0">
                            <td [attr.colspan]="detailTableColspan" class="text-center text-muted">Aucun article</td>
                        </tr>
                        <ng-container *ngFor="let ligne of lignesDocument; let i = index">
                            <ng-container *ngIf="isProductLineVisible(i)">

                                <tr *ngIf="shouldShowProductLineRefOpenSummary(i)"
                                    class="document-product-line__group-header-row document-product-line__group-header-row--ref">
                                    <td class="document-product-line__group-header-cell detail-th-code-barre"></td>
                                    <td class="document-product-line__group-header-cell">
                                        <div class="detail-group-inline detail-group-inline--ref"
                                             (click)="toggleProductLineBarcodeGroup(i, $event)">
                                            <button type="button"
                                                    class="document-barcode-group-toggle"
                                                    (click)="toggleProductLineBarcodeGroup(i, $event)"
                                                    [attr.aria-expanded]="true"
                                                    title="Replier le groupe réf. fabricant">
                                                <i data-feather="chevron-right"
                                                   class="feather-16 document-barcode-group-toggle__icon--open"></i>
                                            </button>
                                            <span class="detail-group-inline__title">{{ getProductLineRefFabricantLabel(i) }}</span>
                                            <span class="detail-group-inline__stats">
                                                <span class="detail-group-inline__stat">
                                                    {{ getProductLineGroupCouleurCount(i) }} couleur{{ getProductLineGroupCouleurCount(i) > 1 ? 's' : '' }}
                                                </span>
                                                <span class="detail-group-inline__stat detail-group-inline__stat--muted">
                                                    {{ getProductLineGroupBarcodeCount(i) }} variante{{ getProductLineGroupBarcodeCount(i) > 1 ? 's' : '' }}
                                                </span>
                                            </span>
                                        </div>
                                    </td>
                                    <td [attr.colspan]="getProductLineRefOpenBannerTrailingColspan()"
                                        class="document-product-line__group-header-cell"></td>
                                </tr>

                                <tr *ngIf="shouldShowProductLineSplitLayout(i) && shouldShowProductLineCouleurBannerRow(i)"
                                    class="document-product-line__group-header-row document-product-line__group-header-row--couleur">
                                    <td class="document-product-line__group-header-cell detail-td-code-barre"></td>
                                    <td class="document-product-line__group-header-cell">
                                        <div class="detail-group-inline detail-group-inline--couleur">
                                            <button type="button"
                                                    class="document-barcode-group-toggle document-barcode-group-toggle--couleur"
                                                    *ngIf="productLineCouleurGroupCanToggle(i)"
                                                    (click)="toggleProductLineCouleurGroup(i, $event)"
                                                    [attr.aria-expanded]="isProductLineCouleurGroupExpanded(i)"
                                                    [title]="isProductLineCouleurGroupExpanded(i) ? 'Masquer les produits de cette couleur' : 'Afficher les produits de cette couleur'">
                                                <i data-feather="chevron-right"
                                                   class="feather-16"
                                                   [class.document-barcode-group-toggle__icon--open]="isProductLineCouleurGroupExpanded(i)"></i>
                                            </button>
                                            <span class="detail-group-inline__couleur">{{ getProductLineCouleurNorm(i) }}</span>
                                            <span class="detail-group-inline__stats">
                                                <span class="detail-group-inline__stat detail-group-inline__stat--muted">
                                                    {{ getProductLineCouleurBarcodeCount(i) }} variante{{ getProductLineCouleurBarcodeCount(i) > 1 ? 's' : '' }}
                                                </span>
                                            </span>
                                        </div>
                                    </td>
                                    <td [attr.colspan]="getProductLineRefOpenBannerTrailingColspan()"
                                        class="document-product-line__group-header-cell"></td>
                                </tr>

                                <tr class="document-product-line__data-row"
                                    [class.document-product-line--variant-row]="isProductLineVariantProductRow(i)"
                                    [class.document-product-line--ref-collapsed]="isProductLineRefGroupCollapsedHead(i)"
                                    [class.document-product-line--couleur-collapsed]="isProductLineCouleurGroupCollapsedHead(i)">
                                    <td class="detail-td-code-barre">
                                        <ng-container *ngIf="shouldShowProductLineBarcodeCell(i); else barcodeGroupCollapsedHint">
                                            <span class="detail-code-barre-readonly"
                                                  [title]="formatBarcodeDisplay(ligne.code_barre)">{{ formatBarcodeDisplay(ligne.code_barre) }}</span>
                                        </ng-container>
                                        <ng-template #barcodeGroupCollapsedHint></ng-template>
                                    </td>
                                    <td>
                                        <ng-container *ngIf="isProductLineRefGroupCollapsedHead(i)">
                                            <div class="detail-group-inline detail-group-inline--ref detail-group-inline--clickable"
                                                 (click)="toggleProductLineBarcodeGroup(i, $event)">
                                                <button type="button"
                                                        class="document-barcode-group-toggle"
                                                        (click)="toggleProductLineBarcodeGroup(i, $event)"
                                                        [attr.aria-expanded]="false"
                                                        title="Afficher par couleur">
                                                    <i data-feather="chevron-right" class="feather-16"></i>
                                                </button>
                                                <span class="detail-group-inline__title">{{ getProductLineRefFabricantLabel(i) }}</span>
                                                <span class="detail-group-inline__stats">
                                                    <span class="detail-group-inline__stat">
                                                        {{ getProductLineGroupCouleurCount(i) }} couleur{{ getProductLineGroupCouleurCount(i) > 1 ? 's' : '' }}
                                                    </span>
                                                    <span class="detail-group-inline__stat detail-group-inline__stat--muted">
                                                        {{ getProductLineGroupBarcodeCount(i) }} variante{{ getProductLineGroupBarcodeCount(i) > 1 ? 's' : '' }}
                                                    </span>
                                                </span>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="isProductLineCouleurGroupCollapsedHead(i)">
                                            <div class="detail-group-inline detail-group-inline--couleur detail-group-inline--clickable"
                                                 (click)="toggleProductLineCouleurGroup(i, $event)">
                                                <button type="button"
                                                        class="document-barcode-group-toggle document-barcode-group-toggle--couleur"
                                                        (click)="toggleProductLineCouleurGroup(i, $event)"
                                                        [attr.aria-expanded]="false"
                                                        title="Afficher les produits de cette couleur">
                                                    <i data-feather="chevron-right" class="feather-16"></i>
                                                </button>
                                                <span class="detail-group-inline__couleur">{{ getProductLineCouleurNorm(i) }}</span>
                                                <span class="detail-group-inline__stats">
                                                    <span class="detail-group-inline__stat detail-group-inline__stat--muted">
                                                        {{ getProductLineCouleurBarcodeCount(i) }} variante{{ getProductLineCouleurBarcodeCount(i) > 1 ? 's' : '' }}
                                                    </span>
                                                </span>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="shouldShowProductLineDesignationLeaf(i)">
                                            <div class="document-product-line__desig-row document-product-line__desig-row--editor detail-product-leaf">
                                                <span class="detail-product-leaf__line">
                                                    <span class="detail-product-leaf__title">{{ getProductLineRefFabricantLabel(i) }}</span>
                                                    <ng-container *ngIf="formatCouleurTailleLine(i)">
                                                        <span class="detail-product-leaf__sep" aria-hidden="true">·</span>
                                                        <span class="detail-product-leaf__attrs">{{ formatCouleurTailleLine(i) }}</span>
                                                    </ng-container>
                                                </span>
                                            </div>
                                        </ng-container>
                                    </td>
                                    <td class="detail-td-num detail-td-qty">{{ getProductLineQuantityDisplay(i) }}</td>
                                    <td class="detail-td-num detail-td-remise">{{ getProductLineRemiseDisplay(i) }}</td>
                                    <td class="detail-td-num detail-td-price">
                                        <ng-container *ngIf="getProductLinePrixUnitaireDisplay(i) as prixA">
                                            <ng-container *ngIf="prixA === '—'; else prixAvecDevise">{{ prixA }}</ng-container>
                                            <ng-template #prixAvecDevise>{{ prixA }} TND</ng-template>
                                        </ng-container>
                                    </td>
                                    <td class="detail-td-num detail-td-price">
                                        <ng-container *ngIf="getProductLineTotalDisplay(i) as prixV">
                                            <ng-container *ngIf="prixV === '—'; else prixVAvecDevise">{{ prixV }}</ng-container>
                                            <ng-template #prixVAvecDevise>{{ prixV }} TND</ng-template>
                                        </ng-container>
                                    </td>
                                </tr>

                            </ng-container>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
                </div>

                <div *ngIf="activeTab === 'paiement'" class="detail-inventaire-tab-panel">
                    <div class="detail-inventaire-table-scroll detail-inventaire-table-scroll--secondary">
                        <table class="styled-table w-full detail-inventaire-lines detail-inventaire-lines--flat">
                            <thead>
                            <tr>
                                <th>DATE</th>
                                <th>MONTANT</th>
                                <th>MODE DE PAIEMENT</th>
                                <th>RÉFÉRENCE</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="paiements.length === 0">
                                <td colspan="4" class="text-center text-muted">Aucun paiement enregistré</td>
                            </tr>
                            <tr *ngFor="let paiement of paiements">
                                <td>{{ formatDate(paiement.date) }}</td>
                                <td>{{ paiement.montant ? formatPrice(paiement.montant) : '--' }} TND</td>
                                <td>{{ paiement.mode_paiement || '--' }}</td>
                                <td>{{ paiement.reference || '--' }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="paiements.length > 0" class="d-flex justify-content-end mt-3">
                        <div class="border-dashed rounded text-center total-box">
                            <div class="mt-2 mb-1 text-primary fw-bold">
                                <strong class="size20">{{ calculateTotalPaiements() }} TND</strong>
                            </div>
                            <p class="size15 text-black mb-0">Total payé</p>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeTab === 'document-lies'" class="detail-inventaire-tab-panel">
                    <div class="detail-inventaire-table-scroll detail-inventaire-table-scroll--secondary">
                        <table class="styled-table w-full detail-inventaire-lines detail-inventaire-lines--flat">
                            <thead>
                            <tr>
                                <th>TYPE</th>
                                <th>RÉFÉRENCE</th>
                                <th>DATE</th>
                                <th>MONTANT</th>
                                <th>STATUT</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="documentsLies.length === 0">
                                <td colspan="5" class="text-center text-muted">Aucun document lié</td>
                            </tr>
                            <tr *ngFor="let doc of documentsLies">
                                <td>{{ doc.type || '--' }}</td>
                                <td>{{ doc.reference || '--' }}</td>
                                <td>{{ formatDate(doc.date) }}</td>
                                <td>{{ doc.montant ? formatPrice(doc.montant) : '--' }} TND</td>
                                <td>
                                    <span class="badge detail-lies-statut" [ngClass]="getLiesStatutBadgeClass(doc.statut)">
                                        {{ doc.statut || '--' }}
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
    </div>
</ng-template>
